var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidStarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93705 0L7.77149 3.71804L11.8748 4.31314L8.9059 7.20827L9.60594 11.2936L5.93705 9.36484L2.26815 11.2936L2.96819 7.20827L0 4.31314L4.1026 3.71804L5.93705 0Z",
    fill: "#3268C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06142 9.12301H5.80771L2.62764 10.7954L3.2347 7.25336L3.15699 7.0116L0.583984 4.50435L4.13864 3.98696L4.34453 3.83818L5.93456 0.616943L7.52459 3.83818L7.72982 3.98696L11.2851 4.50435L8.71213 7.0116L8.63443 7.25336L9.24215 10.7954L6.06142 9.12301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidStarBlack);
export default __webpack_public_path__ + "static/media/kid_starBlack.c133cf83170df2dd574b81bb068dce82.svg";
export { ForwardRef as ReactComponent };